import type {PaginationEllipsisProps} from '@ark-ui/react/pagination';
import {Pagination} from '@ark-ui/react/pagination';
import {ChakraSpan} from '@linx-security/ui/utils/chakra-elements';

import {useStyles} from './context';
import {parts} from './theme/anatomy';

type Props = PaginationEllipsisProps;

export const Ellipsis = (props: Props) => {
  const {ellipsis} = useStyles();
  const {index, ...rest} = props;
  return (
    <Pagination.Ellipsis asChild index={index}>
      <ChakraSpan {...parts.ellipsis.attrs} {...rest} __css={ellipsis} />
    </Pagination.Ellipsis>
  );
};
